import React from 'react';
import { Container } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import SearchCard from './SearchCard';

class GCTransactions extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <SearchCard {...this.props} />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(GCTransactions);
